"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerContainerStyles = styles_1.makeStyles(function () { return ({
    dealerContainer: {},
}); }, { name: 'GqlCheckout_DealerContainer' });
exports.default = dealerContainerStyles;
